import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useChecklistDefaults } from "../context/ChecklistDefaultsContext";
import { useCounty } from "./CountyContext";

const WeatherContext = createContext();

export const WeatherProvider = ({ children }) => {
  const { defaultHazard, defaultAlertType } = useChecklistDefaults();
  const { selectedCounty } = useCounty();

  const [weather, setWeather] = useState(defaultHazard || "Winter Weather");
  const [alertType, setAlertType] = useState(defaultAlertType || "Seasonal");

  const weatherTouchedRef = useRef(false);
  const alertTypeTouchedRef = useRef(false);

  // 1) When county changes, go back to “auto” mode for that new county
  useEffect(() => {
    weatherTouchedRef.current = false;
    alertTypeTouchedRef.current = false;
  }, [selectedCounty]);

  // 2) Sync hazard from per‑county defaults until user changes it
  useEffect(() => {
    if (!defaultHazard) return;
    if (weatherTouchedRef.current) return;
    // IMPORTANT: depend on both defaultHazard AND selectedCounty
    setWeather(defaultHazard);
  }, [defaultHazard, selectedCounty]);

  // 3) Sync alertType from per‑county defaults until user changes it
  useEffect(() => {
    if (!defaultAlertType) return;
    if (alertTypeTouchedRef.current) return;
    setAlertType(defaultAlertType);
  }, [defaultAlertType]);

  const updateWeather = (hazard) => {
    weatherTouchedRef.current = true;
    setWeather(hazard);
    // Allow alertType to follow new hazard defaults again
    alertTypeTouchedRef.current = false;
  };

  const updateAlertType = (type) => {
    alertTypeTouchedRef.current = true;
    setAlertType(type);
  };

  return (
    <WeatherContext.Provider
      value={{ weather, updateWeather, alertType, updateAlertType }}
    >
      {children}
    </WeatherContext.Provider>
  );
};

export const useWeather = () => {
  return useContext(WeatherContext);
};
